import React from "react";
import { documentTypeUrl } from "../../../_constants/staticData";

const Image = (props) => {
  const { url, className, alt, handleClick } = props;
  return (
    <>
      <img
        src={url ? url : documentTypeUrl.brokenImage}
        className={className}
        alt={alt}
        onClick={handleClick}
      />
    </>
  );
};
export default Image;
